import apiTask1 from "../src/assets/images/apitask1.png";
import project1 from "../src/assets/images/covidproject-1.png";
import apiTask2 from "../src/assets/images/apitask2.png";
import apiTask3 from "../src/assets/images/apitask3.png";
import project2 from "../src/assets/images/projects2.png";
import project3 from "../src/assets/images/project3.png";
import project4 from "../src/assets/images/Project4.png";
import project5 from "../src/assets/images/project-5.png";
import project6 from "../src/assets/images/FirebaseTask.png";
import project7 from "../src/assets/images/weather.png";
import todo from "../src/assets/images/todo.png";
import calculator from "../src/assets/images/calculator.png";
import quizapp from "../src/assets/images/quizapp.png";
import scheduler from "../src/assets/images/scheduler.png";
import formImage1 from "../src/assets/images/form1.png";
import formImage2 from "../src/assets/images/form2.png";
import formImage3 from "../src/assets/images/form3.png";
import formImage from "../src/assets/images/form.png";
import debounceDemo from "../src/assets/images/debounce.png";
import multiselect from "../src/assets/images/multiselect.png";
import lockunlock from "../src/assets/images/lockunlock.png";

const featuresData = [
  {
    id: 1,
    title: "Users Resources and List",
    image: apiTask1,
    desc: "Feature1-Server Side Pagination,There are the list of users with profile image also",
    path: "/apitasks/1",
  },
  {
    id: 2,
    title: "Covid19",
    image: apiTask2,
    desc: "Covid19-data-All information regards active case, recovred and deathes",
    path: "/apitasks/2",
  },
  {
    id: 3,
    title: "APITAsk3",
    image: apiTask3,
    desc: "See Posts and Comments per each Posts",
    path: "/apitasks/3",
  },
  {
    id: 4,
    title: "ProductsData fetch Using userReducer Hook",
    image: apiTask3,
    desc: "With the userReducer Hook and useContext Hook there are getting the data from API",
    path: "/apitasks/products",
  },
];
const projectsData = [
  {
    id: 1,
    title: "Covid19 Dashboard",
    image: project1,
    desc: "Covid19 Dashboard using Real Time API",
    path: "/projects/1",
  },
  {
    id: 1,
    title: "ToDo List",
    image: todo,
    desc: "ToDo List ",
    path: "/projects/todo",
  },
  {
    id: 2,
    title: "Student Grade History",
    image: project2,
    desc: "Student Grade Hisstory and add them previous year data",
    path: "/projects/2",
  },
  {
    id: 3,
    title: "VoterForm",
    image: project3,
    desc: "Voterform with Proper Validation using panId,identtiy Id,Image ",
    path: "/projects/3",
  },
  {
    id: 4,
    title: "Student Form",
    image: project4,
    desc: "Dynamic Student Add their Information",
    path: "/projects/4",
  },
  {
    id: 5,
    title: "Language Detection",
    image: project5,
    desc: "Language Detection",
    path: "/projects/5",
  },
  {
    id: 6,
    title: "Voter Counting System Using Firebase",
    image: project6,
    desc: "Using Firebase user can vote any one card!!!",
    path: "/projects/6",
  },
  {
    id: 7,
    title: "Weather API",
    image: project7,
    desc: "shows weather based on search city",
    path: "/projects/weather",
  },
  {
    id: 8,
    title: "Calculator",
    image: calculator,
    desc: "Calculator ",
    path: "/projects/calculator",
  },
  {
    id: 9,
    title: "QuizAPP",
    image: quizapp,
    desc: "QuizAPP-According select answer also see the result also",
    path: "/projects/quizapp",
  },
  {
    id: 10,
    title: "SchedulerApp",
    image: scheduler,
    desc: "Make a schedule of meetings,events,tasks with day,weekly and Monthly scheduler",
    path: "/projects/scheduler",
  },
];

const formData = [
  {
    id: 1,
    title: "Course Enrollment Form",
    image: formImage1,
    desc: "Basic Form Using Formik",
    path: "/form/1",
  },
  {
    id: 2,
    title: "Basic Register Form",
    image: formImage2,
    desc: "Basic Form Using Formik",
    path: "/form/2",
  },
  {
    id: 3,
    title: "Form Container With All Fields",
    image: formImage3,
    desc: "Basic Form Using Formik",
    path: "/form/3",
  },
  {
    id: 4,
    title: "Register Form-With Proper Validation ",
    image: formImage,
    desc: "Client Side Validation Form!",
    path: "/form/4",
  },
];

export const praticeData = [
  {
    id: 1,
    title: "DebounceDemo",
    image: debounceDemo,
    desc: "API call Reduce ",
    path: "/practice/debounce",
  },
  {
    id: 2,
    title: "MultiSelectDropDown",
    image: multiselect,
    desc: "MultiSelected value From DropDown ",
    path: "/practice/multiselected",
  },
  {
    id: 3,
    title: "LockUnlock",
    image: lockunlock,
    desc: "Lock UnLock Functionality  ",
    path: "/practice/lockunlock",
  },
];
export { featuresData, projectsData, formData };
